import React, { useState } from "react";
import styles from "./division.module.css";
import investmentBankImage from "../../assets/images/investment-bank.png";
import privateEquityImage from "../../assets/images/private-equity.png";
import nbfiImage from "../../assets/images/nbfi.png";
import equityResearchImage from "../../assets/images/equity-research.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import arrowLeft from "../../assets/images/Kiwe-arrow-left.svg";
import arrowRight from "../../assets/images/Kiwe-arrow-right.svg";
import { useNavigate } from "react-router-dom";
import LazyLoad from "react-lazyload";

const divisions = [
  {
    id: 1,
    title: "Securities Brokerage",
    description:
      "Your Trusted Gateway to the Egyptian Financial Market Founded in 2007 as the brokerage arm of CFH, Cairo Capital Securities (CCS) has 18 years of market experience, establishing itself as a reliable partner in Egypt’s financial sector. We are dedicated to providing transparent, professional, and compliant brokerage services, fully authorized by the Egyptian Financial Supervisory Authority (EFSA).",
    img: investmentBankImage,
  },
  {
    id: 2,
    title: "Asset Management",
    description:
      "A Legacy of Excellence For over 25 years, Cairo Capital has delivered innovative investment solutions tailored to a diverse clientele. Since our founding in 1995 as CFI, we have led Egypt’s asset management field, achieving consistent, market-leading results. In 2023, acquiring Blom Egypt for Financial Investments further enhanced our capabilities and broadened our offerings under the CCAM brand.",
    img: nbfiImage,
  },
  {
    id: 3,
    title: "Private Equity",
    description:
      "Pioneering Early-Stage Industrial Opportunities The Nile Industrial Investment Fund (NIIF) is Egypt’s first private equity fund dedicated to early-stage industrial projects. With a targeted capacity of EGP 2.5 billion, NIIF leverages Egypt’s economic reforms and market dynamism to invest in transformative, export-driven sectors that reduce import dependency and strengthen the nation’s industrial base.",
    img: privateEquityImage,
  },
  {
    id: 4,
    title: "Venture Capital",
    description:
      "Empowering Fintech Transformation At Cairo Capital, we embrace technology’s potential to reshape financial services. Our Startup Ventures arm invests in early-stage fintech and software companies that enhance our operational infrastructure and service offerings.",
    img: equityResearchImage,
  },
];

const Divisions = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? divisions.length - 1 : prevIndex - 1
    );
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === divisions.length - 1 ? 0 : prevIndex + 1
    );
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    centerPadding: "60px",
  };

  const handleReadMoreClick = (index) => {
    navigate("/our-companies", { state: { activeIndex: index } });
    window.scrollTo(0, 0);
  };

  return (
    <section className={styles.contain}>
      <h2 className={styles.header}>Business Lines</h2>
      <Slider {...sliderSettings} className={styles.slider}>
        {divisions.map((division, index) => (
          <div key={index} className={styles.card}>
            <img
              src={division.img}
              alt={division.title}
              className={styles.cardImage}
            />
            <div className={styles.cardContent}>
              <h3 className={styles.cardTitle}>{division.title}</h3>
              <p className={styles.cardDescription}>{division.description}</p>
              <div
                className={styles.arrowReadMore}
                onClick={() => handleReadMoreClick(index)}
              >
                Read More
                <img
                  src={arrowRight}
                  alt="arrowRight"
                  className={styles.arrow}
                  style={{ marginLeft: ".5rem" }}
                />
              </div>
            </div>
          </div>
        ))}
      </Slider>
      <div className={styles.container}>
        <div className={styles.leftSection}>
          <div className={styles.divisionList}>
            <div>
              <div
                className={`${styles.topLeftSection} ${
                  styles[`image-${currentIndex}`]
                }`}
              >
                <h2 className={styles.title}>
                  {divisions[currentIndex].title}
                </h2>
                <p className={styles.description}>
                  {divisions[currentIndex].description}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.arrows}>
          <img
            src={arrowLeft}
            alt="arrowLeft"
            onClick={handlePrevClick}
            className={styles.arrow}
            style={{ marginRight: "2rem" }}
          />
          <img
            src={arrowRight}
            alt="arrowRight"
            onClick={handleNextClick}
            className={styles.arrow}
          />
        </div>
      </div>
    </section>
  );
};

export default Divisions;
